<template>
  <a-row class="p-2 text-gray">
    <a-col :lg="3" :md="4" :sm="6">
      <i class="lnr lnr-spell-check" /> {{ " " }}
      <span class="ml-2">{{ field.name }}</span>
    </a-col>
    <a-col :lg="21" :md="20" :sm="18" class="text-dark">
      {{ field.value }}
    </a-col>
  </a-row>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
};
</script>
